export const Privacy = () => {
  return (
    <section className="Privacy">
      <div className="--content-container">

        <p className="text-align-center"><em>Terms of Use and Privacy Policy - POMS</em></p>
        <p>End User Agreement</p>
              
        <em>Peace of Mind Spine, LLC TERMS OF USE –</em>

        <em>DO NOT USE THIS WEBSITE FOR EMERGENCY MEDICAL NEEDS. IF YOU EXPERIENCE
        A MEDICAL EMERGENCY, CALL 911 IMMEDIATELY.</em>

        <p>The website located at <a href="https://www.PeaceofMindSpine.com">https://www.PeaceOfMindSpine.com</a> (the “<em>Website</em>”) is published, owned, and operated by Peace of Mind Spine, LLC (“POMS”), a trademark of CRTMD Precision Medical Inc., and related entities (the “Company,” “we,” “us,” and “our”). These Terms of Use (the “<em>Terms</em>”) govern your access to and use of the Website and all other content provided therein for the purposes of providing educational virtual second opinion services through the Website (the “<em>Service(s)</em>”). By using this website, you agree and acknowledge that you are bound by the Terms and comply with applicable law including federal, state, and local tax and
        tariff laws, and regulations. If you do not agree to the Terms, do not use this Website.</p>
        
        <p>The information on the website is for educational purposes only. The data collected on this
        Website does not replace the medical advice of a healthcare provider. Services provided do not
        take the place of your regular healthcare practitioner.</p>

        <p>You agree that you are physically located in the state you choose/have chosen as your current
        location of Chicago, Illinois or Indianapolis, Indiana. You acknowledge that your ability to access
        and use the Services is conditioned upon the truthfulness of this certification and that the
        Providers you access are relying upon this certification to interact with you. In the event that
        your certification is inaccurate, you agree to indemnify the Company, its third-party technology
        platform provider, and the Providers you interact with from any resulting damages, costs, or
        claims.</p>

        <p>You acknowledge that this Service is being provided while you are located in a private residence
        and not a hospital or other facility and is therefore not covered under Medicare.</p>

        <em>1. Purpose of the Website and Telemedicine Overview</em>

        <p>The Website and Services are provided for telemedicine purposes. Telemedicine, in this case,
        involves the use of electronic communications to enable healthcare providers at sites remote
        from participants to provide the Services. Healthcare providers may include, but are not
        necessarily limited to, primary healthcare practitioners, specialists, and/or subspecialists
        (“Providers”). Your Personal Information may be used for review of the data collected and
        provision of the Service. Provision of the Service may include live two-way audio and video and
        other materials (e.g., medical records, data from medical devices, etc.).</p>

        <p>The communication systems used will incorporate network and software security protocols to
        protect the confidentiality of participant information and will include reasonable measures to
        safeguard the data and ensure its integrity against intentional or unintentional corruption.</p>

        <p>A second opinion summary will be provided to the participant at the end of the Service which
        may be kept for the participant’s records and may be shared with other Providers for treatment
        purposes or as otherwise permitted or required by law.</p>
        
        <p>Any information you provide or that is collected by the Company through the Website shall be
        handled in accordance with the Website’s Policy, which is hereby incorporated by reference.</p>

        <p>There are potential risks associated with the use of telemedicine. The Company believes that
        the likelihood of these risks materializing is very low. These risks may include, without limitation,
        the following:</p>

        <ul>
          <li>Delays in the provision of the Services may occur due to deficiencies or failures of the
        equipment.</li>
          <li>Security protocols could fail, causing a breach of privacy of individually identifiable health
        information.</li>
        </ul>

        <h1>HIPAA</h1>

        <p>I understand that the laws that protect privacy and the confidentiality of individually identifiable
        health information, such as the Health Insurance Portability and Accountability Act (“HIPAA”)
        may also apply to telemedicine and may apply to certain aspects of the Services. However, I
        understand that not all information I provide or use on the Website or Services is protected by
        HIPAA. Regardless, I understand that all Personal Information (as defined in the Website
        Privacy Policy) will be processed in accordance with the posted Website Privacy Act Statement
        below.</p>

        <p>Should I engage the Services, I acknowledge that I will receive and review the Company’s
        Privacy Act Statement below which explains how the Company may use and disclose
        individually identifiable health information for treatment, payment, and healthcare operations.</p>

        <em>2. Website Content</em>

        <p>Other than information you receive directly from Providers, the content on the Website should
        not be considered medical advice. You should always talk to an appropriately qualified
        healthcare professional for diagnosis and treatment, including information regarding which
        medications or treatment may be appropriate for you. None of the content on this Website
        represents or warrants that any particular medication or treatment is safe, appropriate, or
        effective for you. Without limitation, the Company does not recommend or endorse any specific
        tests, medications, products, or procedures.</p>

        <em>3. Use of the Website and Services</em>

        <p>The Company, through its third-party technology platform provider, grants you a limited,
        revocable, non-transferable, and non-exclusive right to access and use the Website and the
        software, network facilities, content, and documentation herein (collectively, the “Content”) solely
        for the extent necessary to access and use the Services. Your right to access and use the
        Website shall be limited to non-commercial purposes unless you are otherwise expressly
        authorized by the Company in writing to use the Website for commercial purposes. You agree to
        use the Website and Services only for lawful purposes, comply with all rules governing any
        transactions on and through the Website and comply with applicable laws.</p>

        <em>4. User Account Responsibility</em>

        <p>If you are given or create a password to access the Website or Website portal, you are
        responsible for maintaining the confidentiality of your account and your password. You are
        responsible for all activities that occur under your account, and you agree to notify the Company
        immediately of any unauthorized use of your account. The Company is not responsible for any
        loss that you may incur as a result of any unauthorized person using your account or your
        password.</p>

        <em>5. Prohibited Uses</em>

        <p>You agree that you will not:</p>

        <ul>
          <li>Modify, translate, reverse engineer, disassemble, decompile or create derivative works of
          the Service or allow a third party to do so, whether directly or indirectly;</li>
          <li>Transfer, distribute, sell, lease, rent, disclose, or provide access to the Services to any
          third party or use the Service to provide service bureau, time-sharing, or other services
          to third parties;</li>
          <li>Use the Website in any manner that could damage, disable, overburden, or impair the
          Website or interfere with any other party’s use and enjoyment of it;</li>
          <li>Attempt to gain unauthorized access to any Website account, computer systems, or
          networks associated with the Company or the Website or Services;</li>
          <li>Obtain or attempt to obtain any materials or information through the Website by any
          means not intentionally made available or provided by the Company;</li>
          <li>Use any robot, spider, or other automatic device, process, or means to access the
          Website for any purpose, including monitoring or copying any of the material on the
          Website;</li>
          <li>Introduce any viruses, Trojan horses, worms, bots, logic bombs, or other material which
          is malicious or technologically harmful;</li>
          <li>Attack the Website via a denial-of-service attack or a distributed denial-of-service attack;
          or</li>
          <li>Impersonate or attempt to impersonate the Company, a Company employee, another
          user, or any other person or entity (including, without limitation, by using email addresses
          associated with any of the foregoing).</li>
        </ul>

        <em>6. Notice and Consent to Receipt of Text (SMS) Messaging and Phone Calls</em>

        <p>You may have the opportunity to receive email, SMS or “text” messages, pre-recorded voice
        messages, or auto-dialed phone calls from the Company, its affiliates, and related entities, as
        well as third parties. Such messaging may be used to authenticate your identity or mobile
        device, as well as provide you informational updates about services or products you may have
        requested. In providing your email address, mobile device number or cell phone number to the
        Company, you knowingly consent to such communications from the Company or for the
        Company to use your cell phone number or mobile device number in accordance with the
        Company’s Privacy Act Statement. In providing your number and accepting these Terms, you
        represent that you have the authority to agree to receive emails and text messages at the email
        address and telephone number that you provide to the Company, or from which you filled out
        the form on website or sent the text message request to us. You further acknowledge that no
        purchase is required to opt into this service, and you may opt out at any time by following
        instructions from the Company and as described in the Privacy Act Statement.</p>

        <p>Not all mobile devices or handsets may be supported by this service. The Company and any
        mobile carriers are not liable for delayed or undelivered messages. Message and data rates
        may apply to any text messages. Message frequency depends on the nature of your request.
        You hereby agree to be responsible for all costs, charges, and fees you incur from your service
        or device provider as a result of choosing to receive such messages from the Company.</p>

        <em>7. Third-party Sites</em>

        <p>The Website may contain links to websites controlled or operated by persons and companies
        other than the Company (“Linked Sites”). Linked Sites are not under the control of the Company,
        and the Company is not responsible for the contents of any Linked Site, including without
        limitation any link contained on a Linked Site, or any changes or updates to a Linked Site. The
        Company is not responsible if the Linked Site is not working correctly or for any viruses,
        malware, or other harms resulting from your use of a Linked Site. The Company is providing
        these links to you only as a convenience, and the inclusion of any link does not imply
        endorsement by the Company of the site or any association with its operators. You are
        responsible for viewing and abiding by the privacy policies and terms of use posted on the
        Linked Sites. You are solely responsible for any dealings with third parties who support the
        Company or are identified on the Website, including any delivery of and payment for goods and
        services.</p>

        <em>8. Third-party Applications</em>

        <p>You acknowledge that your access and use of any third-party applications or software on our
        Website and Content (the “Third-party Applications”) is at your discretion and risk, and the
        Company has no liability to you arising from your use of the Third-party Applications. The
        Company hereby disclaims any representation, warranty, or guaranty regarding the Third-party
        Applications, whether expressed, implied, or statutory, including, without limitation, the implied
        warranties of merchantability or fitness for a particular purpose, and any representation,
        warranty, or guaranty regarding the availability, quality, reliability, features, appropriateness,
        accuracy, completeness, or legality of the Third-party Applications, and you agree to indemnify
        and hold the Company harmless for any direct, indirect, punitive, incidental, special, or
        consequential damages, or any damages whatsoever including, without limitation, damages for
        loss of use, arising out of or in any way connected with the use or performance of the
        Third-party Applications.</p>

        <em>9. Intellectual Property Notices</em>

        <p>The Website and Content are protected by copyrights, trademarks, or are subject to other
        proprietary rights. We give you permission to display, download, store, and print the content only
        for your personal, non-commercial use. You agree not to reproduce, retransmit, distribute,
        disseminate, sell, publish, broadcast, or circulate the content received through the Service to
        anyone, except as otherwise authorized under these terms. All software and accompanying
        documentation made available for download from the Service is the copyrighted work of the
        Company or its licensors. Any copy made of information obtained through the Service must
        include all applicable copyright notices.</p>

        <p>You acknowledge and agree that you are solely responsible for complying with the applicable
        restrictions on use of all Content, copyrighted materials, and trademarks that you see, hear, and
        use on the Website. You understand that any unauthorized use of such intellectual property
        would result in irreparable injury for which money damages would be inadequate. You further
        acknowledge that, in the event of any such unauthorized use, the Company or the applicable
        intellectual property owner will have the right, in addition to other remedies available at law and
        in equity, to immediate injunctive relief to prevent any such unauthorized use.</p>

        <em>10. Illinois and Indiana Only</em>

        <p>The Company provides this Website for use only by persons located in the states of Chicago,
        Illinois and Indianapolis, Indiana. We make no claims that the Website or any of its Contents or
        Services are accessible or appropriate outside of the territories. Access to the Website may not
        be legal by certain persons or in certain countries.</p>

        <em>11. Disclaimers</em>

        <p>ACCESS TO THE SERVICE AND THE INFORMATION CONTAINED THEREIN IS PROVIDED
        “AS IS” AND “AS AVAILABLE” WITHOUT ANY WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW,
        THE COMPANY, ITS THIRD-PARTY TECHNOLOGY PLATFORM PROVIDER, AND EACH
        PROVIDER DISCLAIMS ALL WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
        INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTIES OF TITLE,
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT.</p>

        <p>WITHOUT LIMITING THE FOREGOING, THE COMPANY DOES NOT WARRANT THAT
        ACCESS TO THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE, OR THAT
        DEFECTS, IF ANY, WILL BE CORRECTED; NOR DOES THE COMPANY MAKE ANY
        REPRESENTATIONS ABOUT THE ACCURACY, RELIABILITY, CURRENCY, QUALITY,
        COMPLETENESS, USEFULNESS, PERFORMANCE, SECURITY, LEGALITY OR
        SUITABILITY OF THE SERVICE OR ANY OF THE INFORMATION CONTAINED THEREIN.
        YOU EXPRESSLY AGREE THAT YOUR USE OF THE SERVICE AND YOUR RELIANCE
        UPON ANY OF ITS CONTENTS IS AT YOUR SOLE RISK.</p>

        <p>YOU SHALL BE SOLELY AND FULLY RESPONSIBLE FOR ANY DAMAGE TO THE SERVICE
        OR ANY COMPUTER SYSTEM, ANY LOSS OF DATA, OR ANY IMPROPER USE OR
        DISCLOSURE OF INFORMATION ON THE SERVICE CAUSED BY YOU OR ANY PERSON
        USING YOUR USERNAME OR PASSWORD. THE COMPANY CANNOT AND DOES NOT
        ASSUME ANY RESPONSIBILITY FOR ANY LOSS, DAMAGES OR LIABILITIES ARISING
        FROM THE FAILURE OF ANY TELECOMMUNICATIONS INFRASTRUCTURE, OR THE
        INTERNET OR FOR YOUR MISUSE OF ANY PROTECTED HEALTH INFORMATION,
        ADVICE, IDEAS, INFORMATION, INSTRUCTIONS OR GUIDELINES ACCESSED THROUGH
        THE SERVICE.</p>

        <em>12. Limitations of Liability</em>

        <p>IN THE EVENT OF ANY PROBLEM WITH THE SERVICE OR ANY OF ITS CONTENT, YOU
        AGREE THAT YOUR SOLE REMEDY IS TO CEASE USING THE SERVICE. UNDER NO
        CIRCUMSTANCES SHALL THE COMPANY, ITS THIRD-PARTY TECHNOLOGY PLATFORM
        PROVIDER OR SUPPLIER, ANY PROVIDER OR ANY THIRD PARTY WHO PROMOTES THE
        SERVICE OR PROVIDES YOU WITH A LINK TO THE SERVICE BE LIABLE IN ANY WAY
        FOR YOUR USE OF THE SERVICE OR ANY OF ITS CONTENT, INCLUDING, BUT NOT
        LIMITED TO, ANY ERRORS OR OMISSIONS IN ANY CONTENT, ANY INFRINGEMENT BY
        ANY CONTENT OF THE INTELLECTUAL PROPERTY RIGHTS OR OTHER RIGHTS OF
        THIRD PARTIES, OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT
        OF THE USE OF ANY CONTENT.</p>

        <p>UNDER NO CIRCUMSTANCES SHALL THE COMPANY, ITS THIRD-PARTY TECHNOLOGY
        PLATFORM PROVIDER OR SUPPLIERS, ANY PROVIDER, OR ANY THIRD PARTY WHO
        PROMOTES THE SERVICE OR PROVIDES YOU WITH A LINK TO THE SERVICE, BE
        LIABLE FOR ANY PUNITIVE, EXEMPLARY, CONSEQUENTIAL, INCIDENTAL, INDIRECT OR
        SPECIAL DAMAGES (INCLUDING, WITHOUT LIMITATION, ANY PERSONAL INJURY, LOST
        PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR OTHER DATA ON YOUR
        COMPUTER OR OTHERWISE) ARISING FROM OR IN CONNECTION WITH YOUR USE OF
        THE SERVICE, WHETHER UNDER A THEORY OF BREACH OF CONTRACT, NEGLIGENCE,
        STRICT LIABILITY OR OTHERWISE, EVEN IF WE OR THEY HAVE BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES.</p>

        <p>YOU HEREBY RELEASE AND HOLD THE COMPANY, ITS THIRD-PARTY TECHNOLOGY
        PLATFORM PROVIDER, SUPPLIERS, PROVIDERS, AND ANY THIRD PARTY WHO
        PROMOTES THE SERVICE OR PROVIDES YOU WITH A LINK TO THE SERVICE
        HARMLESS FROM ANY AND ALL CLAIMS, DEMANDS, AND DAMAGES OF EVERY KIND
        AND NATURE (INCLUDING, WITHOUT LIMITATION, ACTUAL, SPECIAL, INCIDENTAL AND
        CONSEQUENTIAL), KNOWN AND UNKNOWN, SUSPECTED AND UNSUSPECTED,
        DISCLOSED AND UNDISCLOSED, ARISING OUT OF OR IN ANY WAY CONNECTED WITH
        YOUR USE OF THE SERVICE, TO THE EXTENT PERMITTED UNDER APPLICABLE LAW.
        YOU ACKNOWLEDGE AND AGREE THAT THE COMPANY’S THIRD-PARTY TECHNOLOGY
        PLATFORM PROVIDER IS NOT ENGAGED IN THE PRACTICE OF MEDICINE AND THAT IT
        IS NOT DETERMINING APPROPRIATE MEDICAL USE OF THE SERVICE. IT, ITS
        LICENSORS, SUPPLIER AND ALL THIRD PARTIES WHO PROMOTE THE SERVICE OR
        PROVIDE YOU WITH A LINK TO THE SERVICE EXPRESSLY DISCLAIMS ANY AND ALL
        LIABILITY RESULTING FROM THE DELIVERY OF THE SERVICE, INCLUDING, BUT NOT
        LIMITED TO LIABILITY FOR MEDICAL MALPRACTICE. THE COMPANY IS THE PARTY
        PROVIDING THE TELEMEDICINE SERVICE.</p>

        <em>13. Remote Consultation Services and Limitation of Liability</em>

        <p>The consulting services provided through the Company Services are considered educational
        second opinion services and are different from the diagnostic services provided by a traditional
        in-person encounter with a healthcare provider. The Providers providing these Services will not
        have the benefit of information that would be obtained by examining you in-person and
        observing your physical condition firsthand. Therefore, the Provider may not be aware of facts
        or information that would affect his or her opinion of your condition. In some cases, the missing
        facts may be critical to the accuracy of the Provider’s understanding and opinion.</p>

        <p>To reduce the risk to you of this limitation, the Company strongly encourages you to discuss the
        results of your consultation with your healthcare provider. By requesting an educational second
        opinion through the Services, you acknowledge and agree that:</p>

        <ul>
          <li>You are aware of the limitations of these Services, a type of telemedicine service, and
          agree to solely assume the risk of such limitations.</li>
          <li>The opinion that you will receive is limited and provisional, is not a diagnosis or
          treatment of your condition, and does not include the ordering of diagnostic tests or
          prescribing of any medication.</li>
          <li>The remote consultation is not intended to replace a full medical or an in-person medical
          evaluation with your healthcare provider.</li>
          <li>The Provider does not have important information about you that is usually obtained
          through a physical examination.</li>
          <li>The absence of a physical examination may affect the accuracy of the Provider’s opinion
          about your condition, disease, or injury.</li>
          <li>This Service does not include any emergency care you may require.</li>
          <li>A variety of alternative methods of medical care may be available to you, and you may
          choose one or more of these at any time.</li>
          <li>The Company may cancel the Services at any time in its sole discretion prior to the
          completion of the Services.</li>
          <li>The Services are intended for personal information only and may not be used in litigation
          against any third-party healthcare provider as an expert opinion or otherwise.</li>
          <li>The Services outlined in these Terms and Conditions and rendered hereunder do not
          include establishing a physician-patient relationship in any capacity and do not include
          providing diagnosis, care, or treatment for any individual who has requested this Service
          or may potentially benefit from this Service.</li>
          <li>No warranty or guarantee has been made to you concerning any particular result,
          outcome, or treatment of your condition.</li>
        </ul>

        <em>14. Indemnity</em>

        <p>Without limiting the generality or effect of other provisions of the Terms, as a condition of use,
        you agree to indemnify, hold harmless, and defend the Company, its third-party technology
        platform provider, and its parents, subsidiaries, affiliates, licensors, suppliers and their officers,
        directors, affiliates, subcontractors, agents, and employees (collectively, “Indemnified Parties”
        and each, individually, an “Indemnified Party”) against all costs, expenses, liabilities, and
        damages (including reasonable attorney’s fees) incurred by any Indemnified Party in connection
        with any third-party claims arising out of: (i) your failure to comply with any applicable laws and
        regulations; and (ii) your breach of any of your obligations set forth in these Terms.</p>

        <em>15. Termination and Restriction of Access</em>

        <p>In its sole discretion, the Company or its third-party technology platform provider, if directed by
        the Company, may terminate or suspend your access to the Website for any reason or no
        reason at all. The Company reserves the right to change, suspend, or discontinue all or part of
        the Service, temporarily or permanently, without prior notice. The Company also reserves the
        right to delete or change any username or password at any time, for any reason or for no
        reason at all. The Company shall not be liable for any losses or damages arising from any such
        termination of service.</p>

        <em>16. Limitation on Time to File Claims</em>

        <p>Subject to any applicable law, any cause of action or claim you may have arising out of or
        relating to these Terms or the Website or Services must be commenced within one (1) year after
        the cause of action accrues, otherwise, such cause of action or claim is permanently barred.</p>
        
        <em>17. Governing Law & Jurisdiction</em>

        <p>These Terms are governed by the laws of the State of Illinois, U.S.A. You hereby irrevocably
        consent to the exclusive jurisdiction and venue of the courts in Maricopa County, Arizona U.S.A.
        in all disputes arising out of or relating to the use of the Website.</p>

        <em>18. Changes to these Terms of Use</em>
        
        <p>The Company may update or change these Terms from time to time in order to reflect changes
        in any offered services, changes in the law, or for other reasons as deemed necessary by the
        Company. The effective date of any Terms will be reflected in the “Last Revised” entry at the top
        of these Terms. Your continued use of the Website after any such change is communicated shall
        constitute your consent to such change(s).</p>

        <em>19. General</em>

        <p>You agree that no joint venture, partnership, employment, or agency relationship exists between
        you and the Company as a result of these Terms or use of the Website. You may not assign
        these Terms without the prior written consent of the Company in all instances. The Company
        may assign these Terms, in whole or in part, at any time. The Company’s performance of this
        agreement is subject to existing laws and legal process, and nothing contained in these Terms
        is in derogation of the Company’s right to comply with governmental, court, and law
        enforcement requests or requirements relating to your use of the Website or information
        provided to or gathered by the Company with respect to such use.</p>

        <p>If any part of these Terms are determined to be invalid or unenforceable pursuant to applicable
        law including, but not limited to, the warranty disclaimers and liability limitations set forth above,
        then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable
        provision that most closely matches the intent of the original provision, and the remainder of
        these Terms shall continue in effect.</p>

        <p>These Terms, including the Privacy Act Statement and all other documents expressly
        incorporated herein by reference, constitute the entire agreement between you and the
        Company with respect to the Website, and supersede all prior or contemporaneous
        communications and proposals, whether electronic, oral, or written, between you and the
        Company. A printed version of these Terms and of any notices given in electronic form shall be
        admissible in judicial or administrative proceedings based upon or relating to this agreement to
        the same extent and subject to the same conditions as other business documents and records
        originally generated and maintained in printed form.</p>

        <em>20. Company Contact Information</em>

        <p>We value your opinions and welcome your feedback. Questions can be directed to the
        Company at _______________.</p>

        <em>Privacy Policy for Peace of Mind Spine, LLC</em>

        <em>1. General</em>

        <p>At Peace of Mind Spine, LLC (“Company,” “we,” “us,” and “our”), we are committed to
        safeguarding your privacy. This Privacy Policy (the “Policy”) outlines how we collect, use, and
        protect your information when you interact with our website and services.</p>

        <p>This Policy covers:</p>
        
        <ul>
          <li>The types of information we collect from you or that you provide.</li>
          <li>Our practices for collecting, using, maintaining, protecting, and disclosing that
          information.</li>
          <li>The Website and Services, including interactions via email and other electronic
          communications.</li>
        </ul>
        
        <p>Please review this Policy carefully. By using our Website or Services, you consent to the terms
        outlined herein. If you do not agree with our practices, please do not use our Website. We may
        update this Policy occasionally, so please check back regularly.</p>

        <em>2. Website Terms of Use; Other Agreements and Requirements</em>

        <p>This Policy should be read together with our Website Terms of Use. Additionally, applicable
        privacy laws such as the Health Insurance Portability and Accountability Act (“HIPAA”) may
        apply to our Services. You will receive and must review our Privacy Act Statement prior to
        engaging with our Services. In the event of any conflict between this Policy and the Privacy Act
        Statement, the Privacy Act Statement will prevail.</p>

        <em>3. Information We Collect and How We Collect It</em>

        <em>Information You Provide:</em>
        <p>We collect Personal Information such as:</p>

        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Mailing address</li>
          <li>Date of birth</li>
          <li>Gender</li>
          <li>Pain present and past history</li>
          <li>MRI and procedural documents</li>
          <li>Healthcare provider reviews</li>
          <li>Member login credentials</li>
          <li>Financial information</li>
        </ul>

        <p>You provide this information when you:</p>
        
        <ul>
          <li>Register or schedule an appointment</li>
          <li>Confirm or review an appointment</li>
          <li>Communicate with us</li>
        </ul>

        <em>Automated Information Collection:</em>
        <p>We also collect information automatically through:</p>

        <ul>
          <li><em>Cookies:</em> We use session and persistent cookies to enhance your experience on our
          Website. You can manage cookie settings through your browser.</li>
          <li><em>Google Analytics:</em> We use Google Analytics to analyze Website performance. For
          details, see Google’s Privacy Policy.</li>
          <li><em>Web Beacons:</em> These are used to track email interactions and Website activity.</li>
          <li><em>Embedded Web Links:</em> Track email link usage for performance analysis.</li>
          <li><em>Third-party Websites:</em> We may collect data through marketing tools on third-party sites.</li>
        </ul>

        <em>4. How We Use Your Information</em>

        <p>We use your information to:</p>
        <ul>
          <li>Provide and improve our Services</li>
          <li>Communicate with you</li>
          <li>Conduct research (with your consent)</li>
          <li>Prevent illegal activities</li>
          <li>Comply with legal requirements</li>
        </ul>

        <em>5. How We Share Your Information</em>

        <p>We do not sell or lease your information. We may share it with:</p>
        <ul>
          <li>Trusted business partners under contract</li>
          <li>Legal authorities or to comply with legal obligations</li>
          <li>Third parties in the event of business transactions (mergers, acquisitions)</li>
        </ul>

        <em>6. Your Choices and Privacy Preferences</em>

        <p>You may manage your privacy preferences, including opting out of marketing communications
        by following instructions in the emails you receive. Please note, transactional messages
        necessary for Service provision are not subject to opt-out.</p>

        <em>7. Text Messaging</em>

        <p>By providing your mobile number, you consent to receive SMS, voice messages, or auto-dialed
        calls for authentication and service updates. You can opt out at any time by following the
        provided instructions.</p>

        <em>8. Accuracy and Access to Your Information</em>

        <p>We strive to maintain accurate information. You can access and update your information by
        logging into your account or contacting us directly. Keep your login credentials secure.</p>

        <em>9. Information of Minors</em>

        <p>We do not knowingly collect information from individuals under eighteen. If we discover such
        information, we will take steps to delete it.</p>

        <em>10. Third-party Websites</em>

        <p>Our Website may link to third-party sites. We are not responsible for their privacy practices, and
        we encourage you to review their policies.</p>

        <em>11. Your Indiana and Illinois Rights</em>
        
        <p>Residents of Indiana and Illinois have certain rights regarding their Personal Information. These
        rights include:</p>

        <ul>
          <li>Access: Request a copy of your Personal Information.</li>
          <li>Correction: Request correction of inaccurate information.</li>
          <li>Deletion: Request deletion of your Personal Information (subject to legal requirements).</li>
        </ul>

        <p>Submit requests to our email: support@peacemindspine.com.</p>

        <em>12. For Users Outside Indiana and Illinois</em>

        <p>Our Website and Services are intended for use within Chicago, Illinois and Indianapolis, Indiana
        territories only. If you access our Website from outside the U.S., you consent to the transfer and
        processing of your information in the U.S.</p>

        <em>13. Safeguarding Information</em>

        <p>We use reasonable measures to protect your Personal Information. However, we cannot
        guarantee complete security. Please protect your login credentials and notify us of any
        suspected breaches.</p>

        <em>14. Changes to this Policy</em>

        <p>We may update this Policy periodically. Any changes will be posted on this page with the
        updated effective date.</p>
        
        <em>15. How to Contact Us</em>

        <p>For questions about this Policy or your Personal Information, please contact us at
        <a href="support@peacemindspine.com"> support@peaceofmindspine.com</a>.</p>

        <hr />
        <em>LEGAL NOTICES</em>
        <em>CURRENT PROCEDURAL TERMINOLOGY (“CPT”)</em>

        <p>CPT Copyright © 2024 American Medical Association. All rights reserved.</p>

        <p>Fee schedules, relative value units, conversion factors, and/or related components are not
        assigned by the AMA, are not part of CPT, and the AMA is not recommending their use. The
        AMA does not directly or indirectly practice medicine or dispense medical services. The AMA
        assumes no liability for data contained or not contained herein. Applicable FARs/DFARs
        restrictions apply to government use.</p>

        <p>CPT is a registered trademark of the American Medical Association.</p>

        <em>GEOGRAPHIC RESTRICTIONS</em>

        <p>By using our services, you certify that you are located in the state indicated during registration
        and agree to only interact with a Provider while you are physically present in that state. Your
        ability to access and use our services is conditional upon the truthfulness of this certification,
        which Providers rely on for interaction.</p>

        <em>AGE REQUIREMENTS</em>

        <p>You certify that you are at least 18 years of age and legally qualified to make medical decisions
        on your own behalf. Access to and use of our services is conditional upon this certification of
        age.</p>

        <em>PRIVACY ACT STATEMENT</em>

        <p>This notice describes how your Protected Health Information (PHI) may be used and disclosed
        and how you can access your health information. We are committed to maintaining the privacy
        of your PHI in compliance with the Health Insurance Portability and Accountability Act of 1996
        (HIPAA). This notice outlines our legal duties and privacy practices, which we agree to adhere
        to. We may update this notice and post the revised version on our website or at our office.</p>

        <em>Uses and Disclosures of PHI</em>

        <p>With your written consent, we may use and disclose your PHI in the following ways:</p>

        <ul>
          <li>To treat you or assist others in your treatment.</li>
          <li>To bill and collect payment for the services you receive, including communicating with
        third parties.</li>
          <li>To maintain and improve our practice standards, including Quality Assurance
        procedures.</li>
          <li>As required by Federal, State, or local laws.</li>
        </ul>

        <em>Without Your Consent</em>
        <p>In certain circumstances, we may use or disclose your PHI without your consent:</p>

        <ul>
          <li>To Public Health Authorities and Health Oversight agencies.</li>
          <li>In response to court orders or legal proceedings.</li>
          <li>To Law Enforcement Officials as required by law.</li>
          <li>For organized health care arrangements or to prevent serious threats to health and
        safety.</li>
          <li>For military, national security, correctional institutions, and research purposes.</li>
        </ul>

        <em>Authorization Required</em>
        
        <p>Written authorization is required for:</p>

        <ul>
          <li>Release of PHI to attorneys, non-medical insurance companies, or upon changing
        physicians.</li>
          <li>Use or sale of PHI for marketing purposes.</li>
          <li>Restriction of disclosures to health plans or family members after death.</li>
        </ul>

        <p>You have the right to request restrictions on the use or disclosure of your PHI, request
        confidential communications, inspect and copy your medical information, request amendments,
        and obtain an accounting of disclosures.</p>
        
        <em>Complaints</em>
        
        <p>If you believe your privacy rights have been violated, you may file a complaint with us or with the
        appropriate regulatory bodies. Complaints must be submitted in writing and will not result in any
        penalty.</p>

        <em>Contact Information</em>

        <p>For more information or to file a complaint, please contact:</p>

        <ul>
          <li>Administrator, Peace of Mind Spine, LLC</li>
        </ul>

        <p>Phone: [Your Contact Number]</p>
        <p>Email: [Your Contact Email]</p>
        <p>Address: [Your Address]</p>
        <p><em>Website: </em><a href="https://www.peaceofmindspine.com">https://www.PeaceofMindSpine.com</a></p>
        <p><em>Note: </em>We reserve the right to change this notice at any time.</p>
      </div>
    </section>
  )
}